module.exports = __webpack_public_path__ + "img/1527875188.961d1c36.jpg";